module.exports = __webpack_public_path__ + "static/media/menu-tick.f6f75939.svg";